import React from 'react';

interface State {
  hasError: boolean
}

interface Props {
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<Props, State> {
    state: State = {
      hasError: false
    }
  
    //prop error 
    static getDerivedStateFromError(error: any) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error: any, errorInfo: any) {
      // You can also log the error to an error reporting service
      console.error(error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <h1>Something went wrong.</h1>;
      }
  
      return this.props.children; 
    }
  }

  export default ErrorBoundary;